export const getRegionFormFields = (regionsOfOperation = [], operationalCity = []) => {
  const regions = regionsOfOperation || [];
  const operationalCities = operationalCity || [];
  const firstRegion = regions[0];

  if (!firstRegion) {
    return { state: '', counties: [], cities: [] };
  }

  const operational = operationalCities.find((item) => item.state === firstRegion.state);

  return {
    state: firstRegion.state,
    counties: firstRegion.counties || [],
    cities: operational?.cities || firstRegion.cities || [],
  };
};

export const formatTransportCompanySubmit = (values) => ({
  ...values,
  regionsOfOperation: values.regionsOfOperation?.map(({ state, counties }) => ({ state, counties })) || [],
  operationalCity: values.operationalCity || [],
});

export const handleAddCounties =
  ({ setValues, values }) =>
    () => {
      const indexOfState = values.regionsOfOperation.findIndex((region) => region.state === values.state);
      const operationalCity = [...(values.operationalCity || [])];
      const operationalIndex = operationalCity.findIndex((item) => item.state === values.state);

      if (indexOfState >= 0) {
        values.regionsOfOperation[indexOfState].counties = values.counties;
        values.regionsOfOperation[indexOfState].state = values.state;
      } else {
        values.regionsOfOperation = [
          ...values.regionsOfOperation,
          { state: values.state, counties: values.counties },
        ];
      }

      const operationalEntry = {
        state: values.state,
        counties: values.counties,
        cities: values.cities || [],
      };

      if (operationalIndex >= 0) {
        operationalCity[operationalIndex] = operationalEntry;
      } else {
        operationalCity.push(operationalEntry);
      }

      setValues({
        ...values,
        regionsOfOperation: values.regionsOfOperation,
        operationalCity,
        state: '',
        counties: [],
        cities: [],
      });
    };

export const handleStateSelect = ({ name, value, values, setValues }) => {
  const region = values.regionsOfOperation.find((item) => item.state === value);
  const operational = values.operationalCity?.find((item) => item.state === value);

  setValues({
    ...values,
    [name]: value,
    counties: region?.counties || [],
    cities: operational?.cities || region?.cities || [],
  });
};

const normalizeCountyName = (county) => county.replace(/ County$/i, '').trim().toLowerCase();

export const getCitiesForCounties = (state, selectedCounties, allStateCounties, citiesByState) => {
  if (!state || !selectedCounties?.length || !citiesByState?.[state]) {
    return [];
  }

  const citiesMap = citiesByState[state];
  const isAllCounties =
    allStateCounties?.length > 0 && selectedCounties.length === allStateCounties.length;

  if (isAllCounties) {
    return [...new Set(Object.values(citiesMap).flat())].sort();
  }

  const cities = selectedCounties.flatMap((selectedCounty) => {
    const normalized = normalizeCountyName(selectedCounty);
    const countyKey = Object.keys(citiesMap).find(
      (key) => normalizeCountyName(key) === normalized,
    );

    return countyKey ? citiesMap[countyKey] : [];
  });

  return [...new Set(cities)].sort();
};

export const handleCitiesSelect = (availableCities) => ({ name, value, setFieldValue }) => {
  if (!setFieldValue) {
    return;
  }
  if (!Array.isArray(value) || !value.length) {
    return setFieldValue(name, []);
  }
  if (value.includes('Select All')) {
    return setFieldValue(name, availableCities);
  }
  setFieldValue(name, value);
};

export const handleCountiesSelect = (counties) => ({ name, value, values, setFieldValue }) => {
  if (!Array.isArray(value) || !value.length) {
    setFieldValue(name, []);
    setFieldValue('cities', []);
    return;
  }
  const newCounties = value.includes('Select All') ? counties[values.state] || [] : value;
  setFieldValue(name, newCounties);
  setFieldValue('cities', []);
};

export const handleDelete =
  ({ values, setValues, state, county, city, deleteState, deleteAllCities }) =>
    () => {
      if (deleteState) {
        return setValues({
          ...values,
          regionsOfOperation: values.regionsOfOperation.filter((region) => region.state !== state),
          operationalCity: (values.operationalCity || []).filter((item) => item.state !== state),
        });
      }

      if (deleteAllCities) {
        const operationalCity = [...(values.operationalCity || [])];
        const operationalIndex = operationalCity.findIndex((item) => item.state === state);

        if (operationalIndex >= 0) {
          operationalCity[operationalIndex].cities = [];
        }

        const updates = {
          ...values,
          operationalCity,
        };

        if (values.state === state) {
          updates.cities = [];
        }

        return setValues(updates);
      }

      const indexOfState = values.regionsOfOperation.findIndex((region) => region.state === state);
      const operationalCity = [...(values.operationalCity || [])];
      const operationalIndex = operationalCity.findIndex((item) => item.state === state);

      if (city) {
        if (operationalIndex >= 0) {
          operationalCity[operationalIndex].cities = operationalCity[operationalIndex].cities.filter(
            (item) => item !== city,
          );
        }
      } else {
        values.regionsOfOperation[indexOfState].counties = values.regionsOfOperation[indexOfState].counties.filter(
          (item) => item !== county,
        );

        if (operationalIndex >= 0) {
          operationalCity[operationalIndex].counties = operationalCity[operationalIndex].counties.filter(
            (item) => item !== county,
          );
        }
      }

      setValues({
        ...values,
        regionsOfOperation: values.regionsOfOperation,
        operationalCity,
      });
    };
